// store/selectors/authSelectors.js
import { createSelector } from "@reduxjs/toolkit";
import { ROLE_PERMISSIONS } from "../../permissions/permissions";

export const selectAuth = (state) => state.auth;
export const selectRole = (state) => state.auth.user?.role;
export const selectPermissions = (state) => state.auth.permissions;

// export const selectPermissions = createSelector(
//   [selectRole],
//   (role) => ROLE_PERMISSIONS[role] || []
// );
